@use "../../styles/breakpoint.module.scss" as *;

$one-off-big-breakpoint: "min-width: 1850px";

.content,
.media {
    .small & {
        height: 400px;

        @media ($above-desktop) {
            height: 500px;
        }

        @media ($one-off-big-breakpoint) {
            height: auto;
        }
    }

    .medium & {
        height: 480px;

        @media ($above-desktop) {
            height: 580px;
        }

        @media ($one-off-big-breakpoint) {
            height: auto;
        }
    }

    .large & {
        height: 560px;

        @media ($above-desktop) {
            height: 660px;
        }

        @media ($one-off-big-breakpoint) {
            height: auto;
        }
    }

    .extraLarge & {
        height: 640px;

        @media ($above-desktop) {
            height: 740px;
        }

        @media ($one-off-big-breakpoint) {
            height: auto;
        }
    }
}

// .inner just ended up sticking around for dumb specificity reasons with `img`
.inner .media {
    display: block;
    width: calc(100% + var(--container-margin));
    max-height: 100%;
    max-width: unset;

    @media ($below-mobile) {
        width: calc(100% + var(--container-margin) * 2);
    }

    &[class*="gridStart1"] {
        transform: translateX(calc(var(--container-margin) * -1));

        :is(img, video, iframe) {
            object-position: left;
        }
    }

    &[class*="gridStart7"] {
        :is(img, video, iframe) {
            object-position: right;
        }
    }

    :is(img, video, iframe) {
        object-fit: contain;
    }
}

@media ($above-mobile) {
    .content[class*="gridStart1"] {
        padding-right: var(--spacer-24);
    }
}

@media ($above-tablet) {
    .content {
        --two-column-padding: calc(
            var(--labui-grid-column-width) * 2 + var(--labui-grid-gap)
        );
    }

    .content[class*="gridStart1"] {
        padding-left: var(--two-column-padding);
    }

    .content:not([class*="gridStart1"]) {
        padding-right: var(--two-column-padding);

        // Fuji cheats in his designs
        :is(h1, h2, h3, h4, h5, h6) {
            width: calc(100% + var(--labui-grid-column-width));
        }
    }
}
